module.exports = __webpack_public_path__ + "static/media/caret-circle-up.47bd4b28.svg";